export default __webpack_public_path__ + "static/media/drop.ec35ef3a.svg";